import { useTranslation } from 'react-i18next';
import '../../styles/cards/settingsCommonCard.scss';
import CustomSVGs from '../customSVGs/CustomSVGs';
import MainSquareButton from '../buttons/MainSquareButton';

type Props = {
  mainIconImg?: string;
  mainIconSvg?: any;
  mainIconSvgFillColor?: string;
  mainIconBgColor?: string;
  mainTitle: string;
  subTitle?: string;
  children?: React.ReactNode;
  styles?: React.CSSProperties;
  childrenStyles?: React.CSSProperties;
  onClick?: () => void;
  btnText?: string;
  btnIcon?: any;
  tag?: string;
  tagType?: 'active' | 'inactive';
  titleFontSize?: string;
  titleMarginBottom?: string;
  childMarginTop?: string;
};

const SettingsCommonCard = ({
  mainIconImg,
  mainIconSvg,
  mainIconSvgFillColor,
  mainIconBgColor,
  mainTitle,
  subTitle,
  children,
  styles,
  childrenStyles,
  onClick,
  btnText,
  btnIcon,
  titleFontSize,
  titleMarginBottom,
  tag,
  tagType,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div className='settingsCommonCard' style={styles}>
      <div className='settingsCommonCard-top'>
        <div className='settingsCommonCard-titlesContainer'>
          <div className='settingsCommonCard__title'>
            {mainIconImg && (
              <div
                style={{
                  backgroundColor:
                    mainIconBgColor || 'var(--background-highlight-color-1)',
                }}
                className='settingsCommonCard__title--logoImg'
              >
                <img src={mainIconImg} alt={mainTitle} />
              </div>
            )}
            {mainIconSvg && (
              <div
                style={{
                  backgroundColor:
                    mainIconBgColor || 'var(--background-highlight-color-1)',
                }}
                className='settingsCommonCard__title--logoSvg'
              >
                <CustomSVGs
                  svg={mainIconSvg}
                  fillColor={mainIconSvgFillColor}
                />
              </div>
            )}
            <h2
              style={{
                fontSize: titleFontSize ? titleFontSize : '1.7rem',
                marginBottom: titleMarginBottom ? titleMarginBottom : '0',
              }}
            >
              {t(mainTitle)}
            </h2>
          </div>

          {subTitle && (
            <div className='settingsCommonCard__subtitle'>
              <span>{t(subTitle)}</span>
            </div>
          )}
        </div>

        {onClick && btnText && (
          <div className='settingsCommonCard__action'>
            <MainSquareButton
              value={btnText}
              icon={btnIcon}
              type='button'
              onClick={onClick}
            />
          </div>
        )}
      </div>

      {children && (
        <div className='settingsCommonCard__content' style={childrenStyles}>
          {children}
        </div>
      )}
    </div>
  );
};

export default SettingsCommonCard;
